import CountUp from 'react-countup';
import { useEffect, useRef, useState } from 'react';

const CountUpComponent = ({
  startValue = 0,
  endValue = 0,
  suffix = '',
  color = '#000',
  decimals = 0,
  duration = 1,
}) => {
  return (
    <div>
      <CountUp
        start={startValue}
        end={endValue}
        duration={duration}
        suffix={suffix}
        decimals={decimals}
        enableScrollSpy={true}
        scrollSpyOnce={true}
        style={{ color: color }}
      />
    </div>
  );
};

export default CountUpComponent;
